import { render, staticRenderFns } from "./DocumentRevisionHistory.vue?vue&type=template&id=efeb0c02&scoped=true&"
import script from "./DocumentRevisionHistory.vue?vue&type=script&lang=js&"
export * from "./DocumentRevisionHistory.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRevisionHistory.vue?vue&type=style&index=0&id=efeb0c02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efeb0c02",
  null
  
)

export default component.exports